module.exports = __webpack_public_path__ + "static/media/1009980.53f7ea32.jpg";